import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

// Components
import { NavbarComponent } from '../../../template/components/navbar/navbar.component';

// Services
import { ContextService } from '../../services/context.service';

// Models
import { CreateContext } from '../../models/context.model';
import { ToastService } from '../../../shared/services/toast.service';
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";

type CreateContextForm = {
  [K in keyof CreateContext]: FormControl<CreateContext[K]>;
};

@Component({
    selector: 'app-context-create',
    imports: [NavbarComponent, ReactiveFormsModule, LoadingButtonComponent],
    templateUrl: './context-create.component.html'
})
export class ContextCreateComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly router = inject(Router);
  private readonly contextSrv = inject(ContextService);
  private readonly toastSrv = inject(ToastService);

  navList = [{ label: 'Lista Contesti', routePath: '/contexts' }, { label: 'Nuovo Contesto', routePath: '/contexts/new' }];

  loading = false;

  createContextForm: FormGroup<CreateContextForm> = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(255)]],
    description: ['', Validators.maxLength(255)]
  });

  onSubmit() {
    if (this.createContextForm.valid) {
      this.loading = true;
      console.log('Form Submitted', this.createContextForm.value);
      this.contextSrv.createContext(this.createContextForm.getRawValue())
        .pipe(finalize(() => this.loading = false))
        .subscribe(
          {
            next: () => {
              this.toastSrv.show({ type: 'success', message: 'Contesto creato' });
              this.router.navigate(['/contexts']);
            }
          });
    }
  }

  onCancel() {
    this.createContextForm.reset();
  }

  get name() { return this.createContextForm.get('name'); }
  get description() { return this.createContextForm.get('description'); }
}
